/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

import {
  getItemMaster,
  getLevel1ByLevel,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel4ByLevel,
  getLevelsByWarehouse,
  getSubModulesByRoleId,
  getSuidForReprint,
  getWarehouses,
  reprint,
} from "../../../store";

import Select from "react-select";
import "../../../index.css";

import { useFormik } from "formik";
import * as Yup from "yup";
import TextError from "../../../utils/TextError";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// @mui material components
import Alert from "@mui/material/Alert";
import Card from "@mui/material/Card";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";

// Notification
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

import Cookies from "universal-cookie";

const cookies = new Cookies();

function RPTATW({
  getMaterialDesc,
  //   getMaterialDescReducer,
  underTestPrint,

  getItemMaster,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getWarehouses,
  getLevelsByWarehouse,
  warehouses,
  itemMaster,
  getSuidForReprintReducer,
  getSuidForReprint,
  reprint,
  getLevel1ByLevel,
  getLevel3ByLevel,
  getLevel1ByLevelReducer,
  getLevel2ByLevelReducer,
  getLevel3ByLevelReducer,
  getLevel4ByLevelReducer,
  levelsByWarehouseReducer,
  getLevel2ByLevel,
  getLevel4ByLevel,
}) {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let printerConfig = cookies.get("printerConfigForWarehouse");

  // let printerId = loginDetails.data.printerId;

  let printerId = cookies.get("printerIdForWarehouse");

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  useEffect(() => {
    getItemMaster(jwtToken);
  }, []);

  useEffect(() => {
    getWarehouses(jwtToken);
  }, []);
  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  // let reprintNewModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "30810d8c-f3e1-4edf-95a6-12234b215f47"
  // );

  let reprintNewModule = true;

  let locationFilterAccess = false;

  // let printButton = reprintNewModule
  //   ? reprintNewModule.actionId.includes("c69be8fd-e6ab-4afa-b82c-23a482471087")
  //   : null;

  let printButton = true;

  const [isSuccessUnderTestPrint, setIsSuccessUnderTestPrint] = useState(false);
  const [isErrorUnderTestPrint, setIsErrorUnderTestPrint] = useState(false);

  useEffect(() => {
    if (isErrorUnderTestPrint) {
      setTimeout(() => {
        setIsErrorUnderTestPrint(false);
      }, 3000);
    }
  }, [isErrorUnderTestPrint]);

  useEffect(() => {
    if (isSuccessUnderTestPrint) {
      setTimeout(() => {
        setIsSuccessUnderTestPrint(false);
      }, 3000);
    }
  }, [isSuccessUnderTestPrint]);

  const locationOptions = [
    {
      label: "2008",
      value: "2008",
    },
    {
      label: "2009",
      value: "2009",
    },
    {
      label: "2010",
      value: "2010",
    },
  ];
  const [itemCodeSelected, setItemCodeSelected] = useState("");

  const [locationSelected, setLocationSelected] = useState("");

  const handleLocationChange = (selectedZone) => {
    setLocationSelected(selectedZone);
  };
  const [SuidsSelected, setSuidsSelected] = useState("");

  const handleSuidChange = (selectedOption) => {
    setSuidsSelected(selectedOption);
    const suid = selectedOption ? selectedOption : null;
    const serialNumber = selectedOption
      ? suidOptions.find((item) => item.value === selectedOption.value)
          ?.serialNumber
      : "";
    const sku = selectedOption
      ? suidOptions.find((item) => item.value === selectedOption.value)?.sku
      : "";
    const qty = selectedOption
      ? suidOptions.find((item) => item.value === selectedOption.value)?.qty
      : "";
    const uom = selectedOption
      ? suidOptions.find((item) => item.value === selectedOption.value)?.uom
      : "";
    const locationCode = selectedOption
      ? suidOptions.find((item) => item.value === selectedOption.value)
          ?.locationCode
      : "";

    formik.setFieldValue("suid", suid);
    formik.setFieldValue("sku", sku);
    formik.setFieldValue("qty", qty);
    formik.setFieldValue("uom", uom);
    formik.setFieldValue("locationCode", locationCode);
    formik.setFieldValue("serialNumber", serialNumber);
  };
  const handleDocumentTypeChange = (selectedOption) => {
    setItemCodeSelected(selectedOption);
    // setMovementTypeSelected("");
    // setparameterSelected("");
  };
  const [warehouseSelected, setwarehouseSelected] = useState("");
  const handleWarehouseChange = (selectedOption) => {
    setwarehouseSelected(selectedOption);
    setlevel1Selected("");
    setlevel2Selected("");
    setlevel3Selected("");
    setlevel4Selected("");
    // setparameterSelected("");
  };

  const [materialDescription, setMaterialDescription] = useState("");
  const [uom, setUom] = useState("");

  // useEffect(() => {
  //   getSuidForReprint(
  //     itemCodeSelected ? itemCodeSelected?.value : "",
  //     jwtToken
  //   );
  // }, [itemCodeSelected]);

  const initialValues = {
    itemCode: "",
    // materialDescription: materialDescription,
    suid: "",
    // uom: uom,
    sku: "",
    serialNumber: "",
    qty: "",
    uom: "",
    locationCode: "",
    // dateOfReceipt: new Date().toISOString().slice(0, 10),
  };

  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];

    data.map((item) => {
      tempItemCodeOptions.push({
        label: `${item.itemCode}/${item.itemDescription}`,
        value: item.itemId,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  // useEffect(() => {
  //   if (searchTerm.length > 1 || searchTerm === "") {
  //     (getSuidForReprint(searchTerm,jwtToken,)); // Dispatch the search term to Redux action
  //   }
  // }, [searchTerm, , jwtToken]);

  const [suidOptions, setSuidOptions] = useState([]);

  useEffect(() => {
    let tempSuidOptions = [];
    let data = getSuidForReprintReducer.suids.data
      ? getSuidForReprintReducer.suids.data
      : [];
    data.map((suid) => {
      tempSuidOptions.push({
        label: suid.suid,
        value: suid.suid,
        serialNumber: suid.serialNumber,
        sku: suid.sku,
        uom: suid.uom,
        qty: suid.qty,
        locationCode: suid.locationCode,
      });
    });
    setSuidOptions(tempSuidOptions);
  }, [getSuidForReprintReducer]);
  // useEffect(() => {
  //   getPicklistAgeing(
  //     itemCodeSelected ? itemCodeSelected.value : "",
  //     movementTypeSelected ? movementTypeSelected.value : "",
  //     parameterSelected ? parameterSelected.value : "",
  //     jwtToken
  //   );
  // }, [itemCodeSelected, movementTypeSelected, parameterSelected]);

  const validationSchema = Yup.object({
    // itemCode: Yup.string()
    //   .trim("Please enter a valid sap code")
    //   .strict(true)
    //   .required("Enter the SAP Code"),
    // netWt: Yup.string()
    //   .trim("Please enter a valid net wt")
    //   .strict(true)
    //   .required("Enter the Net Wt"),
    // // uom: Yup.string()
    // //   .trim("Please enter a valid uom")
    // //   .strict(true)
    // //   .required("Enter the uom"),
    // deliveryNo: Yup.string()
    //   .trim("Please enter a valid delivery no")
    //   .strict(true)
    //   .required("Enter the Delivery No"),
    // location: Yup.object()
    //   // .trim("Please enter a valid location")
    //   // .strict(true)
    //   .required("Select the Location"),
    // printQty: Yup.number()
    //   .positive("Please enter a positive number")
    //   .required("Enter the Print Qty"),
    // dateOfReceipt: Yup.string().required("Select the Receipt Date"),
  });

  const [printErrorMsg, setPrintErrorMsg] = useState("");

  const onSubmit = async (values, { resetForm }) => {
    let payload = {
      suid: SuidsSelected?.value,
      printerId: printerId,
    };

    let res = await reprint(payload, jwtToken);

    if (res.status) {
      resetForm();
      setItemCodeSelected("");
      setSuidsSelected("");
      setwarehouseSelected("");
      setlevel1Selected("");
      setlevel2Selected("");
      setlevel3Selected("");
      setlevel4Selected("");

      formik.setFieldValue("locationCode", "");
      setIsSuccessUnderTestPrint(true);
    }
    if (!res.status) {
      setPrintErrorMsg(res.data.data.msg);
      setIsErrorUnderTestPrint(true);
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
  });

  const searchSapCodeHandler = async () => {
    let res = await getMaterialDesc(formik.values.sapCode, jwtToken);

    if (!res.status) {
      SapCodeNotification(res?.data?.data?.msg);
    }
  };

  const SapCodeNotification = (msg) =>
    toast.error(msg, {
      position: "top-center",
      autoClose: 2000,
    });

  //   useEffect(() => {
  //     setMaterialDescription(
  //       getMaterialDescReducer?.desc[0]?.materialDescription
  //     );
  //     setUom(getMaterialDescReducer?.desc[0]?.uom);
  //   }, [getMaterialDescReducer]);

  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [level1Selected, setlevel1Selected] = useState("");
  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = warehouses.warehouses ? warehouses.warehouses : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
        key: warehouse.warehouseCode,
      });
    });
    setWarehouseOptions(tempWarehouseOptions);
  }, [warehouses]);

  const handlelevel1Change = (selectedOption) => {
    setlevel1Selected(selectedOption);
    setlevel2Selected("");

    setlevel3Selected("");
    setlevel4Selected("");
    // setparameterSelected("");
  };

  const [level1Options, setLevel1Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel1ByLevelReducer.level1ByLevel.data
      ? getLevel1ByLevelReducer.level1ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
        key: level.locationName,
      });
    });

    // if (tempLevelOptions.length === 1) {
    //   setlevel1Selected(tempLevelOptions[0]);
    // }
    // else {
    //   setlevel1Selected(null);
    // }

    setLevel1Options(tempLevelOptions);
  }, [getLevel1ByLevelReducer]);

  const [level2Selected, setlevel2Selected] = useState("");

  const handlelevel2Change = (selectedOption) => {
    setlevel2Selected(selectedOption);

    setlevel3Selected("");
    setlevel4Selected("");
    // setMovementTypeSelected("");
    // setparameterSelected("");
  };

  const [level3Selected, setlevel3Selected] = useState("");

  const handlelevel3Change = (selectedOption) => {
    setlevel3Selected(selectedOption);

    setlevel4Selected("");
    // setMovementTypeSelected("");
    // setparameterSelected("");
  };
  const [level4Selected, setlevel4Selected] = useState("");

  const handlelevel4Change = (selectedOption) => {
    setlevel4Selected(selectedOption);
    // setMovementTypeSelected("");
    // setparameterSelected("");
  };

  const [level4Options, setLevel4Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel4ByLevelReducer.level4ByLevel.data
      ? getLevel4ByLevelReducer.level4ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    // if (tempLevelOptions.length === 1) {
    //   setlevel4Selected(tempLevelOptions[0]);
    // }
    // else {
    //   setlevel4Selected(null);
    // }

    setLevel4Options(tempLevelOptions);
  }, [getLevel4ByLevelReducer]);

  const [level3Options, setLevel3Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel3ByLevelReducer.level3ByLevel.data
      ? getLevel3ByLevelReducer.level3ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    // if (tempLevelOptions.length === 1) {
    //   setlevel3Selected(tempLevelOptions[0]);
    // }
    // else {
    //   setlevel3Selected(null);
    // }
    setLevel3Options(tempLevelOptions);
  }, [getLevel3ByLevelReducer]);

  const [level2Options, setLevel2Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel2ByLevelReducer.level2ByLevel.data
      ? getLevel2ByLevelReducer.level2ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    // if (tempLevelOptions.length === 1) {
    //   setlevel2Selected(tempLevelOptions[0]);
    // }
    // else {
    //   setlevel2Selected(null);
    // }

    setLevel2Options(tempLevelOptions);
  }, [getLevel2ByLevelReducer]);

  const concatenatedLocation = [
    warehouseSelected?.label,
    level1Selected?.label,
    level2Selected?.label,
    level3Selected?.label,
    level4Selected?.label,
  ]
    .filter(Boolean)
    .join("-");

  useEffect(() => {
    getSuidForReprint(
      itemCodeSelected ? itemCodeSelected?.value : "",
      debouncedSearchTerm,
      warehouseSelected?.label,
      concatenatedLocation,
      jwtToken,
    );
  }, [
    itemCodeSelected,
    debouncedSearchTerm,
    warehouseSelected,
    concatenatedLocation,
  ]);

  const [levelOptions, setLevelOptions] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = levelsByWarehouseReducer.levelsByWarehouse.data
      ? levelsByWarehouseReducer.levelsByWarehouse.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level?.rltName,
        value: level?.rltLevel,
      });
    });
    setLevelOptions(tempLevelOptions);
  }, [levelsByWarehouseReducer]);

  useEffect(() => {
    getLevelsByWarehouse(warehouseSelected?.value, jwtToken);
  }, [warehouseSelected]);

  return (
    <div>
      <>
        <DashboardLayout>
          <DashboardNavbar />
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Card sx={{ width: "60%", marginTop: "90px" }}>
              <MDBox ml={2} mt={2}>
                <MDTypography variant="h4" fontWeight="medium">
                  Reprint
                </MDTypography>
              </MDBox>

              <hr style={{ marginTop: "0.1rem" }} />

              <MDBox
                component="form"
                role="form"
                onSubmit={formik.handleSubmit}
              >
                <Grid container>
                  <Grid item xs={4}>
                    <MDBox p={1}>
                      <MDTypography
                        variant="h6"
                        style={{ fontSize: 14, fontWeight: 500 }}
                      >
                        Warehouse
                      </MDTypography>

                      <Select
                        isClearable
                        className="select-css"
                        placeholder="Select Warehouse..."
                        name="warehouse"
                        value={warehouseSelected}
                        options={warehouseOptions}
                        onChange={(selectedOption) => {
                          handleWarehouseChange(selectedOption);

                          getLevel1ByLevel(selectedOption?.value, 0, jwtToken);

                          getLevel4ByLevel(selectedOption?.value, 0, jwtToken);
                          formik.setFieldValue("warehouse", selectedOption);
                        }}
                      />
                      {formik.touched.materialDescription &&
                        formik.errors.materialDescription && (
                          <TextError msg={formik.errors.materialDescription} />
                        )}
                    </MDBox>
                  </Grid>
                  <Grid item xs={4}>
                    <MDBox p={1}>
                      <MDTypography
                        variant="h6"
                        style={{ fontSize: 14, fontWeight: 500 }}
                      >
                        Zone
                      </MDTypography>

                      <Select
                        isClearable
                        className="select-css"
                        placeholder="Select Zone..."
                        name="level1"
                        value={level1Selected}
                        isDisabled={
                          (warehouseSelected ? false : true) ||
                          levelOptions[0]?.value !== 1
                        }
                        options={level1Options}
                        onChange={(selectedOption) => {
                          handlelevel1Change(selectedOption);

                          getLevel2ByLevel(
                            warehouseSelected?.value,
                            selectedOption?.value,

                            jwtToken,
                          );
                          getLevel4ByLevel(
                            warehouseSelected?.value,
                            selectedOption?.value,

                            jwtToken,
                          );

                          formik.setFieldValue("level1", selectedOption);
                        }}
                      />
                      {formik.touched.materialDescription &&
                        formik.errors.materialDescription && (
                          <TextError msg={formik.errors.materialDescription} />
                        )}
                    </MDBox>
                  </Grid>
                  <Grid item xs={4}>
                    <MDBox p={1}>
                      <MDTypography
                        variant="h6"
                        style={{ fontSize: 14, fontWeight: 500 }}
                      >
                        Section
                      </MDTypography>

                      <Select
                        isClearable
                        className="select-css"
                        placeholder="Select Section..."
                        name="level2"
                        value={level2Selected}
                        isDisabled={
                          levelOptions[0]?.value == 1 && !level1Selected
                            ? true
                            : false ||
                              !(
                                levelOptions[0]?.value === 2 ||
                                levelOptions[1]?.value === 2
                              )
                        }
                        options={level2Options}
                        onChange={(selectedOption) => {
                          handlelevel2Change(selectedOption);

                          getLevel3ByLevel(
                            warehouseSelected?.value,
                            selectedOption?.value,

                            jwtToken,
                          );

                          formik.setFieldValue("level2", selectedOption);
                        }}
                      />
                      {formik.touched.materialDescription &&
                        formik.errors.materialDescription && (
                          <TextError msg={formik.errors.materialDescription} />
                        )}
                    </MDBox>
                  </Grid>
                  <Grid item xs={4}>
                    <MDBox p={1}>
                      <MDTypography
                        variant="h6"
                        style={{ fontSize: 14, fontWeight: 500 }}
                      >
                        Partition
                      </MDTypography>

                      <Select
                        isClearable
                        className="select-css"
                        placeholder="Select Partition..."
                        name="level3"
                        value={level3Selected}
                        isDisabled={
                          ((levelOptions[0]?.value == 2 ||
                            levelOptions[1]?.value == 2) &&
                          !level2Selected
                            ? true
                            : false) ||
                          !(
                            levelOptions[0]?.value === 3 ||
                            levelOptions[1]?.value === 3 ||
                            levelOptions[2]?.value === 3
                          )
                        }
                        options={level3Options}
                        onChange={(selectedOption) => {
                          handlelevel3Change(selectedOption);

                          getLevel4ByLevel(
                            warehouseSelected?.value,
                            selectedOption?.value,

                            jwtToken,
                          );

                          formik.setFieldValue("level3", selectedOption);
                        }}
                      />
                      {formik.touched.materialDescription &&
                        formik.errors.materialDescription && (
                          <TextError msg={formik.errors.materialDescription} />
                        )}
                    </MDBox>
                  </Grid>
                  <Grid item xs={4}>
                    <MDBox p={1}>
                      <MDTypography
                        variant="h6"
                        style={{ fontSize: 14, fontWeight: 500 }}
                      >
                        Location
                      </MDTypography>

                      <Select
                        isClearable
                        className="select-css"
                        placeholder="Select Location..."
                        name="level4"
                        value={level4Selected}
                        options={level4Options}
                        // isDisabled={level3Selected ? false : true}
                        isDisabled={
                          ((levelOptions[0]?.value == 3 ||
                            levelOptions[1]?.value == 3 ||
                            levelOptions[2]?.value == 3) &&
                          !level3Selected
                            ? true
                            : false) ||
                          !(
                            levelOptions[0]?.value === 4 ||
                            levelOptions[1]?.value === 4 ||
                            levelOptions[2]?.value === 4 ||
                            levelOptions[3]?.value === 4
                          )
                        }
                        onChange={(selectedOption) => {
                          handlelevel4Change(selectedOption);
                          formik.setFieldValue("level4", selectedOption);
                        }}
                      />
                      {formik.touched.materialDescription &&
                        formik.errors.materialDescription && (
                          <TextError msg={formik.errors.materialDescription} />
                        )}
                    </MDBox>
                  </Grid>
                  <Grid item xs={12}>
                    <MDBox p={1}>
                      <MDTypography
                        variant="h6"
                        style={{ fontSize: 14, fontWeight: 500 }}
                      >
                        ItemCode/Description
                      </MDTypography>

                      <Select
                        isClearable
                        className="select-css"
                        placeholder="Select Item..."
                        name="itemCode"
                        value={itemCodeSelected}
                        options={itemCodeOptions}
                        onChange={(selectedOption) => {
                          handleDocumentTypeChange(selectedOption);
                          formik.setFieldValue("itemCode", selectedOption);
                        }}
                      />
                      {formik.touched.materialDescription &&
                        formik.errors.materialDescription && (
                          <TextError msg={formik.errors.materialDescription} />
                        )}
                    </MDBox>
                  </Grid>
                  <Grid item xs={12}>
                    <MDBox p={1}>
                      <MDTypography
                        variant="h6"
                        style={{ fontSize: 14, fontWeight: 500 }}
                      >
                        SUID
                      </MDTypography>

                      <Select
                        isClearable
                        className="select-css"
                        placeholder="Select suid..."
                        name="suid"
                        onInputChange={(newValue) => setSearchTerm(newValue)} // Update search term as user types
                        value={SuidsSelected}
                        options={suidOptions}
                        onChange={(selectedOption) => {
                          handleSuidChange(selectedOption);
                          formik.setFieldValue("suid", selectedOption);
                        }}
                      />
                      {formik.touched.materialDescription &&
                        formik.errors.materialDescription && (
                          <TextError msg={formik.errors.materialDescription} />
                        )}
                    </MDBox>
                  </Grid>
                  <Grid item xs={6}>
                    <MDBox p={1}>
                      <MDTypography
                        variant="h6"
                        style={{ fontSize: 14, fontWeight: 500 }}
                      >
                        SKU
                      </MDTypography>
                      <MDInput
                        type="text"
                        name="sku"
                        fullWidth
                        disabled
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.sku}
                        error={formik.touched.sku && formik.errors.sku && true}
                      />
                      {formik.touched.sku && formik.errors.sku && (
                        <TextError msg={formik.errors.sku} />
                      )}
                    </MDBox>
                  </Grid>
                  <Grid item xs={6}>
                    <MDBox p={1}>
                      <MDTypography
                        variant="h6"
                        style={{ fontSize: 14, fontWeight: 500 }}
                      >
                        Serial Number W
                      </MDTypography>
                      <MDInput
                        type="text"
                        name="serialNumber"
                        fullWidth
                        disabled
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.serialNumber}
                        error={
                          formik.touched.serialNumber &&
                          formik.errors.serialNumber &&
                          true
                        }
                      />
                      {formik.touched.serialNumber &&
                        formik.errors.serialNumber && (
                          <TextError msg={formik.errors.serialNumber} />
                        )}
                    </MDBox>
                  </Grid>
                  <Grid item xs={6}>
                    <MDBox p={1}>
                      <MDTypography
                        variant="h6"
                        style={{ fontSize: 14, fontWeight: 500 }}
                      >
                        QTY
                      </MDTypography>
                      <MDInput
                        type="text"
                        name="qty"
                        fullWidth
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.qty}
                        error={formik.touched.qty && formik.errors.qty && true}
                        disabled
                      />
                      {formik.touched.qty && formik.errors.qty && (
                        <TextError msg={formik.errors.qty} />
                      )}
                    </MDBox>
                  </Grid>
                  <Grid item xs={6}>
                    <MDBox p={1}>
                      <MDTypography
                        variant="h6"
                        style={{ fontSize: 14, fontWeight: 500 }}
                      >
                        UOM
                      </MDTypography>
                      <MDInput
                        type="text"
                        name="uom"
                        fullWidth
                        disabled
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.uom}
                        error={formik.touched.uom && formik.errors.uom && true}
                      />
                      {formik.touched.uom && formik.errors.uom && (
                        <TextError msg={formik.errors.uom} />
                      )}
                    </MDBox>
                  </Grid>

                  <Grid item xs={6}>
                    <MDBox p={1}>
                      <MDTypography
                        variant="h6"
                        style={{ fontSize: 14, fontWeight: 500 }}
                      >
                        Location
                      </MDTypography>
                      <MDInput
                        type="text"
                        name="locationCode"
                        fullWidth
                        disabled
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.locationCode}
                        error={
                          formik.touched.locationCode &&
                          formik.errors.locationCode &&
                          true
                        }
                      />
                      {formik.touched.locationCode &&
                        formik.errors.locationCode && (
                          <TextError msg={formik.errors.locationCode} />
                        )}
                    </MDBox>
                  </Grid>
                </Grid>
                <MDBox className="mt-3">
                  <Collapse in={isErrorUnderTestPrint}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorUnderTestPrint(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {/* Could not print the Under Test label! */}
                      {printErrorMsg}
                    </Alert>
                  </Collapse>
                  <Collapse in={isSuccessUnderTestPrint}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessUnderTestPrint(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Printed Successfully!
                    </Alert>
                  </Collapse>
                </MDBox>

                <MDBox display="flex" style={{ float: "right" }} p={1}>
                  {printerId == undefined && (
                    <MDTypography
                      style={{
                        color: "red",
                        marginRight: "10px",
                        fontSize: "15px",
                        marginTop: "5px",
                      }}
                    >
                      Please configure the Printer!
                    </MDTypography>
                  )}
                  <MDButton
                    color="success"
                    type="submit"
                    size="small"
                    // disabled={
                    //   !formik.isValid ||
                    //   !printUnderTest ||
                    //   !materialDescription ||
                    //   !uom ||
                    //   printerId == undefined
                    // }
                    disabled={!printButton}
                  >
                    Print
                  </MDButton>
                </MDBox>
              </MDBox>
            </Card>
          </div>
          <ToastContainer />
          <br />
          <br />
          <br />
          <Footer />
        </DashboardLayout>
      </>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    // getMaterialDescReducer: state.getMaterialDescReducer,
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    itemMaster: state.itemMaster,

    getLevel1ByLevelReducer: state.getLevel1ByLevelReducer,
    getLevel2ByLevelReducer: state.getLevel2ByLevelReducer,
    getLevel3ByLevelReducer: state.getLevel3ByLevelReducer,
    getLevel4ByLevelReducer: state.getLevel4ByLevelReducer,
    warehouses: state.warehouses,
    getSuidForReprintReducer: state.getSuidForReprintReducer,

    levelsByWarehouseReducer: state.levelsByWarehouseReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),

    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),

    getWarehouses: (jwtToken) => dispatch(getWarehouses(jwtToken)),

    getSuidForReprint: (
      documentTypeSelected,
      searchTerm,
      warehouseSelected,
      concatenatedLocation,
      jwtToken,
    ) =>
      dispatch(
        getSuidForReprint(
          documentTypeSelected,
          searchTerm,
          warehouseSelected,
          concatenatedLocation,
          jwtToken,
        ),
      ),
    reprint: (payload, jwtToken) => dispatch(reprint(payload, jwtToken)),

    getLevel1ByLevel: (dWarehouseSelected, parentId, jwtToken) =>
      dispatch(getLevel1ByLevel(dWarehouseSelected, parentId, jwtToken)),
    getLevel2ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel2ByLevel(warehouseId, parentId, jwtToken)),
    getLevel3ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel3ByLevel(warehouseId, parentId, jwtToken)),
    getLevel4ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel4ByLevel(warehouseId, parentId, jwtToken)),
    getLevelsByWarehouse: (warehouseId, jwtToken) =>
      dispatch(getLevelsByWarehouse(warehouseId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RPTATW);
